import type { DetailHomeGiftProductResponse } from '__generated__/api/unauth';
import type { QueryClient } from '@tanstack/react-query';

import { UnauthQueryOptions } from '@/api';

import { PRODUCT_DETAIL_STALE_TIME } from '../_constants';

export const fetchProductDetail = async (
  queryClient: QueryClient,
  productNumber: string,
): Promise<DetailHomeGiftProductResponse | null> => {
  const queryOptions = UnauthQueryOptions[
    'get:/wello/v2/allows/home/gift-product/{productNumber}'
  ]({ path: { productNumber } });

  try {
    const data = await queryClient.fetchQuery({
      ...queryOptions,
      staleTime: PRODUCT_DETAIL_STALE_TIME,
    });

    return data.context ?? null;
  } catch {
    return null;
  }
};
